// extracted by mini-css-extract-plugin
export default {"MissingItemInfo":"V6sIQTJS"};